import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

//Layouts

import LandingAuthLayout from "../Layouts/LandingAuthLayout";
// import ModalManager from "../pages/Authentication/Modal/ModalManager";
// import { ModalProvider } from "../pages/AuthenticationInner/ModalProvider";
import { authProtectedRoutes, landingRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from "./AuthProtected";
import NonAuthLayout from "../Layouts/NonAuthLayout";
import Layouts from "../Layouts";
import Loading from "../Components/Common/Loading/Component/Loading";

//routes

const Index = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route>
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <Suspense fallback={<Loading />}>
                  <NonAuthLayout>{route.component}</NonAuthLayout>
                </Suspense>
              }
              key={idx}
              exact={true}
            />
          ))}
          <Route path="*" element={<Navigate to="/" />} />
        </Route>

        <Route>
          {authProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <AuthProtected>
                  <Layouts>{route.component}</Layouts>
                </AuthProtected>
              }
              key={idx}
              exact={true}
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
